window.addEventListener('turbolinks:load', () => {
  // Initial setup for existing fields
  $('.nested-fields.row_send_whatsapp_message_fields').each(function() {
    setupNodeListeners($(this));
    initBotTriggers($(this));
    updateNodeBadge($(this));
    checkSelect($(this));
  });

  filterBotsByInstance();

  // Setup for new fields added via Cocoon
  $('#followup_messages').on('cocoon:after-insert', function(e, insertedItem) {
    setupNodeListeners($(insertedItem));
    initBotTriggers($(insertedItem));
    updateNodeBadge($(insertedItem));
    checkSelect($(insertedItem));
    filterBotsByInstance();
  });

  $('#followup_whatsapp_instance_id').on('change', function() {
    filterBotsByInstance();
  });
});

function getBotsData() {
  const container = document.getElementById('followup-flow-container');
  if (!container || !container.dataset.bots) return [];
  try {
    return JSON.parse(container.dataset.bots);
  } catch (e) {
    return [];
  }
}

function filterBotsByInstance() {
  const selectedInstanceId = $('#followup_whatsapp_instance_id').val();
  $('select.select-bot-flow').each(function() {
    const currentVal = $(this).val();
    $(this).find('option').each(function() {
      const instId = $(this).data('instance-id');
      if (!instId || !selectedInstanceId || String(instId) === String(selectedInstanceId)) {
        $(this).show().prop('disabled', false);
      } else {
        $(this).hide().prop('disabled', true);
      }
    });
  });
}

function initBotTriggers(node) {
  const botSelect = node.find('select.select-bot-flow');
  const botId = botSelect.val();
  const triggerContainer = node.find('.bot-trigger-container');
  const savedTriggerId = botSelect.data('selected-trigger');

  if (botId) {
    triggerContainer.show();
    populateBotTriggers(node, botId, savedTriggerId);
  } else {
    triggerContainer.hide();
  }
}

function populateBotTriggers(node, botId, selectedTriggerId) {
  const botsData = getBotsData();
  const bot = botsData.find(b => String(b.id) === String(botId));
  const triggerSelect = node.find('select.select-bot-trigger');
  const currentVal = selectedTriggerId || triggerSelect.val();

  triggerSelect.empty();
  triggerSelect.append(new Option('Início padrão do Bot', ''));

  if (bot && bot.triggers && bot.triggers.length > 0) {
    bot.triggers.forEach(t => {
      const isSelected = String(t.id) === String(currentVal);
      triggerSelect.append(new Option(t.title, t.id, isSelected, isSelected));
    });
  }
}

function setupNodeListeners(node) {
  // Update badge when time, kind, keyword, or bot changes
  node.find('input[name*="message_time"], select[name*="message_kind"], input[name*="keyword"], select.select-bot-flow').on('input change', function() {
    updateNodeBadge(node);
  });

  // Show/Hide fields and update accept when type changes
  node.find('select.message_type').on('change', function() {
    checkSelect(node);
  });

  // Handle bot selection change
  node.find('select.select-bot-flow').on('change', function() {
    const botId = $(this).val();
    const triggerContainer = node.find('.bot-trigger-container');
    const triggerSelect = node.find('select.select-bot-trigger');

    if (!botId) {
      triggerContainer.slideUp();
      triggerSelect.empty().append(new Option('Início padrão do Bot', ''));
    } else {
      triggerContainer.slideDown();
      populateBotTriggers(node, botId, null);
    }
    updateNodeBadge(node);
  });
}

function updateNodeBadge(node) {
  const time = node.find('input[name*="message_time"]').val() || '0';
  const kind = node.find('select[name*="message_kind"] option:selected').text() || 'Minuto(s)';
  const keyword = node.find('input[name*="keyword"]').val();
  const kwLabel = keyword ? `[${keyword.toUpperCase()}] ` : '';
  const botSelect = node.find('select.select-bot-flow');
  const botName = botSelect.val() ? botSelect.find('option:selected').text() : '';
  const botLabel = botName ? `🤖 [Bot: ${botName}] ` : '';
  node.find('.interval-badge').text(`${botLabel}${kwLabel}Aguardar ${time} ${kind}`);
}

function checkSelect(node) {
  const select = node.find('select.message_type');
  const val = select.val();
  const fileFieldContainer = node.find('input[type="file"]').closest('.field');
  
  // Show/Hide file field based on type
  // Types: 1 (Text), 2 (Image), 3 (Video), 4 (Audio), 5 (PDF). 
  // Basically show file if it's not text (1)
  if (val === '1') {
    fileFieldContainer.hide();
  } else {
    fileFieldContainer.show();
    
    // Set appropriate accepted file types
    const input = fileFieldContainer.find('input[type="file"]');
    if (val === '2') input.attr("accept", '.png, .jpg, .jpeg, .gif');
    else if (val === '3') input.attr("accept", '.mp4, video/mp4');
    else if (val === '4') input.attr("accept", 'audio/*');
    else if (val === '5') input.attr("accept", '.pdf');
  }
}

window.validateFiles = function (inputFile) {
  var maxExceededMessage = "Tamanho máximo por arquivo (15 MB)";
  var maxFileSize = $(inputFile).data('max-file-size');
  var sizeExceeded = false;
  var extError = false;

  // Extensions listed in the accept attribute or defaults
  var acceptAttr = $(inputFile).attr('accept');
  var allowedExtension = ["jpg", "jpeg", "gif", "png", "mp3", "mp4", "pdf", "mov", "ogg", "csv", "md", "txt", "json", "xls", "xlsx", "doc", "docx"];

  if (acceptAttr && acceptAttr.includes('.')) {
    allowedExtension = acceptAttr.split(',').map(function (ext) {
      return ext.trim().replace('.', '').toLowerCase();
    });
  }

  var extErrorMessage = "Apenas arquivos " + allowedExtension.map(function(ext) { return "." + ext; }).join(", ") + " são permitidos.";

  $.each(inputFile.files, function () {
    if (this.size && maxFileSize && this.size > parseInt(maxFileSize)) { sizeExceeded = true; };
    var extName = this.name.split('.').pop().toLowerCase();
    if ($.inArray(extName, allowedExtension) == -1) { extError = true; };
  });

  if (sizeExceeded) {
    window.alert(maxExceededMessage);
    $(inputFile).val('');
  };

  if (extError) {
    window.alert(extErrorMessage);
    $(inputFile).val('');
  };
}
